import React, { useState, useEffect, useCallback, useReducer } from 'react';

import { Helmet } from 'react-helmet';
import LWCLayout from '../layouts/LWCLayout';
import FormUtils from '../utils/FormUtils';
import ReCAPTCHA from "react-google-recaptcha";

const OptInResearch = ({ pageContext }) => {
    const [countryList, setCountryList] = useState();
    const [isLoading, setLoading] = useState(false);
    const [apiMessage, setApiMessage] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const recaptchaRef = React.createRef();
    const { slug } = pageContext;

    const inputReducer = (state, action) => {
        switch (action?.type) {
            case "CLEARSTATE":
                return {};
            default:
                return { ...state, [action.id]: action.value };
        }
    }

    const [inputValues, dispatchFieldChanges] = useReducer(inputReducer, {});
    const [fieldErrors, dispatchFieldErrorsChanges] = useReducer(inputReducer, {});

    useEffect(() => {
        getListOfCountries();
        asyncPrepareFields();
    }, []);

    useEffect(() => {
        if (countryList?.length > 0) {
            setComboOptions();
        }
    }, [countryList]);

    useEffect(() => {
        if (inputValues['Country']) {
            const selectedCountry = countryList?.filter(country => country.label === inputValues['Country']);
            dispatchFieldChanges({ id: 'termsAndCondition', value: selectedCountry[0] });
            dispatchFieldErrorsChanges({ id: 'legalText', value: null });
            dispatchFieldChanges({ id: 'legalText', value: null });
            asyncPrepareFields();
        }
    }, [inputValues['Country']])


    const showRecaptchaValidation = (msg) => {
        let errorDiv = document.querySelector('#recaptcha-error').parentElement

        if (msg) {
            errorDiv.classList.add('slds-has-error')
        }
        else {
            errorDiv.classList.remove('slds-has-error')
        }
    }

    const handleRecaptchaFail = () => {
        setRecaptchaToken('')
    }

    const handleRecaptcha = (value) => {
        setRecaptchaToken(value)
        dispatchFieldErrorsChanges({ id: 'recaptcha-widget', value: null })
    }

    const getListOfCountries = useCallback(() => {
        fetch(process.env.GATSBY_COUNTRY_LIST_ENDPOINT).then(r => r.json()).then(data => {
            setCountryList(data)
        })
    }, []);

    const setComboOptions = () => {
        customElements.whenDefined("tds-combobox").then(() => {
            const dropdownsOptions = { ...getDropdownsOptions() }

            if (slug === 'agentforce-research-sign-up') {
                if (countryList?.length > 0) {
                    dropdownsOptions['Country'] = countryList.map(item => item.label);
                }
            } else {
                if (countryList?.length > 0) {
                    dropdownsOptions['Country'] = countryList.filter(item => item.label === 'United States');
                }
            }

            Object.keys(dropdownsOptions).forEach(combo => {
                const comboEl = document.querySelector(`#${combo}`);

                if (comboEl && comboEl.dataset && !Object.hasOwnProperty.call(comboEl.dataset, 'alreadySetOptions')) {
                    comboEl.dataset.alreadySetOptions = true;
                    if (slug === 'research-sign-up' && combo === 'Country') {
                        comboEl.options = [{ label: dropdownsOptions[combo][0]['label'], value: dropdownsOptions[combo][0]['label'] }];
                    } else {
                        comboEl.options = dropdownsOptions[combo].map(item => { return { label: item, value: item } });
                    }
                }
            })

        })
    }

    const handleSubmitForm = (e) => {
        e.preventDefault();
        const hasAnyFormErrors = validateFields();
        console.log('ERERER', hasAnyFormErrors)

        if (!hasAnyFormErrors) {
            let formObject = {};

            formObject['handlerName'] = (slug === 'agentforce-research-sign-up') ? 'AgentforceResearchProgramFormHandler' : 'ResearchProgramFormHandler';
            formObject['First_Name__c'] = inputValues['FirstName'].trim();
            formObject['Last_Name__c'] = inputValues['LastName'].trim();
            formObject['Phone_Number__c'] = inputValues['PhoneNumber'];
            formObject['Number_of_Employees__c'] = inputValues['Number_Of_Employees'];
            formObject['Success_Plan__c'] = inputValues['Success_Plan'];
            formObject['Business_Email_Address__c'] = inputValues['BusinessEmail'];
            formObject['Company_Name__c'] = inputValues['CompanyName'].trim();
            formObject['Job_Title__c'] = inputValues['JobTitle'].trim();
            formObject['Country__c'] = inputValues['Country'];
            // formObject['State__c'] = inputValues['State__c'];
            formObject['Industry__c'] = inputValues['Industry'];

            if (slug === 'agentforce-research-sign-up') {
                formObject['IsAgentforce__c'] = true;
            }

            console.log('DDDD', formObject)

            setLoading(true);

            fetch(process.env.GATSBY_OPTIN_RESEARCH_DRM_ENDPOINT, {
                method: 'POST',
                mode: 'cors',
                referrerPolicy: 'origin-when-cross-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Captcha-Response': recaptchaToken,
                    'Access-Control-Allow-Headers': 'origin, X-Custom-Header',
                    'Access-Control-Allow-Method': 'POST',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify(formObject)

            }).then(res => res.json()).then(res => {
                setLoading(false);
                setApiMessage(res);
            });

        }
    }


    const handleTdsTextareaOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id

        if (inputId) {
            dispatchFieldChanges({ id: inputId, value: val })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const validateFields = () => {
        const fieldsToValidate = document.querySelectorAll('[data-validate]');
        let valid = false;

        fieldsToValidate.forEach(field => {
            let message = ''
            let hasAnyError = false;

            if (field.tagName === 'TDS-INPUT' && field.shadowRoot) {
                const value = field.shadowRoot.querySelector("input").value;
                if (field.type === "text" || field.type === "email") {
                    if ((value.trim() === '' && field.dataset.validate === 'FirstName') || (value !== '' && field.dataset.validate === 'FirstName' && FormUtils.isValidUrl(value)) || (value !== '' && field.dataset.validate === 'FirstName' && FormUtils.isLimitCharacters(value, 255))) {
                        message = 'Please enter first name.'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'LastName') || (value !== '' && field.dataset.validate === 'LastName' && FormUtils.isValidUrl(value)) || (value !== '' && field.dataset.validate === 'LastName' && FormUtils.isLimitCharacters(value, 255))) {
                        message = 'Please enter last name.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'BusinessEmail' || value !== '' && field.dataset.validate === 'BusinessEmail' && !FormUtils.isValidEmail(value)) {
                        message = 'Please enter valid email address. example@yourdomain.com'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'CompanyName') || (value !== '' && field.dataset.validate === 'CompanyName' && FormUtils.isValidUrl(value)) || (value !== '' && field.dataset.validate === 'CompanyName' && FormUtils.isLimitCharacters(value, 255))) {
                        message = 'Please enter your company name.'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'JobTitle') || (value !== '' && field.dataset.validate === 'JobTitle' && FormUtils.isValidUrl(value)) || (value !== '' && field.dataset.validate === 'JobTitle' && FormUtils.isLimitCharacters(value, 255))) {
                        message = 'Please enter your job title.'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'PhoneNumber') || (value !== '' && field.dataset.validate === 'PhoneNumber' && !FormUtils.isValidPhoneNumber(value))) {
                        message = 'Please enter your phone number. XXX-XXX-XXXX.'
                        hasAnyError = true
                    }
                    else if (inputValues['termsAndCondition']?.showLegalCheckbox && field.id === 'legalText' && (inputValues['legalText'] === false || !inputValues['legalText'])) {
                        message = 'Please Accept the Privacy Statement'
                        hasAnyError = true
                    }
                }
            }

            if (field.tagName === 'TDS-COMBOBOX' && field.shadowRoot) {
                if (field.id === 'Country' && !inputValues['Country']) {
                    message = 'Please select the country/region.'
                    hasAnyError = true
                }
                else if (field.id === 'State__c' && !inputValues['State__c']) {
                    message = 'Please select the state/province.'
                    hasAnyError = true
                }
                else if (field.id === 'Number_Of_Employees' && !inputValues['Number_Of_Employees']) {
                    message = 'Please select the number of employees.'
                    hasAnyError = true
                }
                else if (field.id === 'Industry' && !inputValues['Industry']) {
                    message = 'Please select the industry.'
                    hasAnyError = true
                }
                else if (field.id === 'Success_Plan' && !inputValues['Success_Plan']) {
                    message = 'Please select the success plan.'
                    hasAnyError = true
                }
            }

            if (hasAnyError) {
                valid = hasAnyError;
                dispatchFieldErrorsChanges({ id: field.id, value: message })

            } else {
                dispatchFieldErrorsChanges({ id: field.id, value: null })
            }
        })

        if (!recaptchaToken) {
            valid = true;
            let recaptchaError = 'Please complete the re-captcha verification.';
            showRecaptchaValidation(recaptchaError);
            dispatchFieldErrorsChanges({ id: 'recaptcha-widget', value: recaptchaError });
        }

        return valid;

    }

    const handleTdsInputOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id
        if (inputId) {
            dispatchFieldChanges({ id: inputId, value: val });
        }
    }, []);

    const handleTdsComboboxOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id
        if (inputId) {
            if (e.target.multiple) {
                const arr = JSON.parse(JSON.stringify(val))
                dispatchFieldChanges({ id: inputId, value: arr })

            } else {
                dispatchFieldChanges({ id: inputId, value: val })
            }
        }
    });

    const asyncPrepareFields = async () => {
        const tdsElementNames = ['tds-input', 'tds-combobox', 'tds-checkbox', 'tds-textarea']

        const promises = [...tdsElementNames].map(element => {
            if (element === "tds-input") {
                customElements.whenDefined("tds-input").then(() => {
                    document.querySelectorAll("tds-input").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            // Add Event Listener
                            input.addEventListener('change', handleTdsInputOnChange)
                            input.dataset.onChangeBinded = true
                        }
                    })
                })
            }

            if (element === "tds-combobox") {
                customElements.whenDefined("tds-combobox").then(() => {
                    document.querySelectorAll("tds-combobox").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            input.dataset.onChangeBinded = true
                            // Add Event Listener
                            input.addEventListener('change', handleTdsComboboxOnChange)
                        }
                    })
                })
            }

            if (element === "tds-textarea") {
                customElements.whenDefined("tds-textarea").then(() => {
                    document.querySelectorAll("tds-textarea").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            input.dataset.onChangeBinded = true
                            // Add Event Listener
                            input.addEventListener('change', handleTdsTextareaOnChange)
                        }
                    })
                })
            }
        })

        // Wait for all the undefinedElements to be defined
        await Promise.all(promises)
    }

    const getDropdownsOptions = () => {
        return {
            // State__c: [
            //     'Alabama',
            //     'Alaska',
            //     'American Samoa',
            //     'Arizona',
            //     'Arkansas',
            //     'California',
            //     'Colorado',
            //     'Connecticut',
            //     'Delaware',
            //     'District of Columbia',
            //     'Federated States of Micronesia',
            //     'Florida',
            //     'Georgia',
            //     'Guam',
            //     'Hawaii',
            //     'Idaho',
            //     'Illinois',
            //     'Indiana',
            //     'Iowa',
            //     'Kansas',
            //     'Kentucky',
            //     'Louisiana',
            //     'Maine',
            //     'Maryland',
            //     'Marshall Islands',
            //     'Massachusetts',
            //     'Michigan',
            //     'Minnesota',
            //     'Mississippi',
            //     'Missouri',
            //     'Montana',
            //     'Nebraska',
            //     'Nevada',
            //     'New Hampshire',
            //     'New Jersey',
            //     'New Mexico',
            //     'New York',
            //     'North Carolina',
            //     'North Dakota',
            //     'Northern Mariana Islands',
            //     'Ohio',
            //     'Oklahoma',
            //     'Oregon',
            //     'Palau',
            //     'Pennsylvania',
            //     'Puerto Rico',
            //     'Rhode Island',
            //     'South Carolina',
            //     'South Dakota',
            //     'Tennessee',
            //     'Texas',
            //     'Utah',
            //     'Vermont',
            //     'Virgin Islands',
            //     'Virginia',
            //     'Washington',
            //     'West Virginia',
            //     'Wisconsin',
            //     'Wyoming'
            // ],
            Number_Of_Employees: [
                '1-5 employees',
                '6-20 employees',
                '21-100 employees',
                '101-500 employees',
                '501-3,500 employees',
                '3501+ employees'
            ],
            Success_Plan: [
                'Standard: I use self-serve resources like Help Documentation, Trailhead, Trailblazer Community, etc.',
                'Premier: I can schedule Expert Coaching sessions',
                'Signature: I work with a Customer Success Manager',
                'I am not sure'
            ],
            Industry: [
                'Automotive',
                'Communications',
                'Consumer Goods',
                'Education',
                'Energy & Utilities',
                'Engineering, Contruction & Real Estate',
                'Financial Services',
                'Healthcare & Life Sciences',
                'Manufacturing',
                'Media',
                'Nonprofit',
                'Professional Services',
                'Public Sector',
                'Retail',
                'Technology',
                'Travel, Transporation & Hospitality',
                'Other'
            ]
        }
    }

    return (
        <LWCLayout slug={slug}>
            <Helmet>
                <title>{slug === 'agentforce-research-sign-up' ? 'Agentforce Feedback Council Form' : 'Opt-In Research Form'}</title>
            </Helmet>
            <div className="optinresearch-content">
                {!apiMessage?.status && (
                    <>
                        <div className="header-section">
                            {slug === 'research-sign-up' && (
                                <>
                                    <h1 className="main-title">Join the Salesforce Customer Success Research Program</h1>
                                    <p className="title-desc">Complete the form below to be invited to upcoming feedback opportunities. Your input will go directly to Salesforce experience designers.</p>
                                </>
                            )}
                            {slug === 'agentforce-research-sign-up' && (
                                <>
                                    <div>
                                        <img src="https://developer.salesforce.com/resources2/agentforce-research-sign-up/agentforce-agent-astro.png" width="120px" height="100px" alt="Agentforce logo" />
                                    </div>
                                    <h1 className="main-title">Join the Salesforce Agentforce Feedback Council</h1>
                                    <p className="title-desc">Complete the form below to be invited to upcoming Agentforce feedback opportunities. Your input will go directly to Salesforce experience designers and as a council member, you’ll get exclusive opportunities to:</p>
                                    <ul>
                                        <li>Validate new features before they launch</li>
                                        <li>Participate in deep-dive research studies
                                        </li>
                                        <li>Share insights that directly influence product decisions
                                        </li>
                                    </ul>
                                </>
                            )}
                        </div>


                        <div className="flex-container">
                            <div className="flex-item">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    First Name
                                </div>
                                <tds-input
                                    type="text"
                                    id="FirstName"
                                    placeholder="Enter your First Name"
                                    required="true"
                                    data-validate="FirstName"
                                    value={inputValues['FirstName']}
                                    error-message={fieldErrors['FirstName']}
                                />
                            </div>
                            <div className="flex-item mobile-top">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Last Name
                                </div>
                                <tds-input
                                    type="text"
                                    id="LastName"
                                    placeholder="Enter your Last Name"
                                    required="true"
                                    data-validate="LastName"
                                    value={inputValues['LastName']}
                                    error-message={fieldErrors['LastName']}
                                />
                            </div>
                        </div>

                        <div className="flex-container">
                            <div className="flex-item">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Business Email Address
                                </div>
                                <tds-input
                                    type="text"
                                    id="BusinessEmail"
                                    placeholder="Enter your Business Email Address"
                                    required="true"
                                    data-validate="BusinessEmail"
                                    value={inputValues['BusinessEmail']}
                                    error-message={fieldErrors['BusinessEmail']}
                                />
                            </div>
                            <div className="flex-item mobile-top">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Company Name
                                </div>
                                <tds-input
                                    type="text"
                                    id="CompanyName"
                                    placeholder="Enter your Company Name"
                                    required="true"
                                    data-validate="CompanyName"
                                    value={inputValues['CompanyName']}
                                    error-message={fieldErrors['CompanyName']}
                                />
                            </div>
                        </div>

                        <div className="flex-container">
                            <div className="flex-item">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Job Title
                                </div>
                                <tds-input
                                    type="text"
                                    id="JobTitle"
                                    placeholder="Enter your Job Title"
                                    required="true"
                                    data-validate="JobTitle"
                                    value={inputValues['JobTitle']}
                                    error-message={fieldErrors['JobTitle']}
                                />
                            </div>
                            <div className="flex-item mobile-top">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Country/Region {slug === 'research-sign-up' && '(Accepting US Only)'}
                                </div>
                                <tds-combobox
                                    id="Country"
                                    required="true"
                                    placeholder="Select your Country/Region"
                                    data-validate="Country"
                                    value={inputValues['Country']}
                                    error-message={fieldErrors['Country']}
                                />
                            </div>
                        </div>

                        <div className="flex-container">
                            <div className="flex-item">
                                {/* <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    State/Province
                                </div>
                                <tds-combobox
                                    id="State__c"
                                    required="true"
                                    placeholder="Select your State/Province"
                                    data-validate="State__c"
                                    value={inputValues['State__c']}
                                    error-message={fieldErrors['State__c']}
                                /> */}
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Phone Number
                                </div>
                                <tds-input
                                    type="text"
                                    id="PhoneNumber"
                                    placeholder="Enter your 10-digit Phone Number"
                                    required="true"
                                    data-validate="PhoneNumber"
                                    value={inputValues['PhoneNumber']}
                                    error-message={fieldErrors['PhoneNumber']}
                                />
                            </div>
                            <div className="flex-item mobile-top"></div>
                        </div>

                        <div className="flex-container">
                            <div className="flex-item">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Number of Employees
                                </div>
                                <tds-combobox
                                    id="Number_Of_Employees"
                                    required="true"
                                    placeholder="Select your Employees"
                                    data-validate="Number_Of_Employees"
                                    value={inputValues['Number_Of_Employees']}
                                    error-message={fieldErrors['Number_Of_Employees']}
                                />
                            </div>
                            <div className="flex-item mobile-top">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Industry
                                </div>
                                <tds-combobox
                                    id="Industry"
                                    required="true"
                                    placeholder="Select your Industry"
                                    data-validate="Industry"
                                    value={inputValues['Industry']}
                                    error-message={fieldErrors['Industry']}
                                />
                            </div>
                        </div>
                        <div className="flex-container">
                            <div className="flex-item full-width">
                                <div className="u-input-label">
                                    <span className="u-required-simbol">*</span>
                                    Success Plan
                                </div>
                                <tds-combobox
                                    id="Success_Plan"
                                    required="true"
                                    placeholder="Select your Success Plan"
                                    data-validate="Success_Plan"
                                    value={inputValues['Success_Plan']}
                                    error-message={fieldErrors['Success_Plan']}
                                />
                            </div>
                        </div>

                        {inputValues['termsAndCondition']?.showMarketingText && (
                            <div className="fifth-page margin-top">
                                <tds-input type="checkbox" id="Privacy_Consent__c" label={inputValues['termsAndCondition']?.marketingText} />
                            </div>
                        )}

                        {inputValues['termsAndCondition']?.legalText && (
                            <div className="sixth-page margin-top">
                                {inputValues['termsAndCondition']?.showLegalCheckbox && (
                                    <tds-input
                                        className={`display-inline`}
                                        type="checkbox"
                                        id="legalText"
                                        data-validate='legalCheckbox'
                                    />
                                )}
                                <span
                                    className='legal-txt'
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            inputValues['termsAndCondition']?.legalText
                                    }}
                                />
                                {fieldErrors['legalText'] && (
                                    <div className="legal-txt-error">{fieldErrors['legalText']}</div>
                                )}
                                {inputValues['termsAndCondition']?.learnMore && (
                                    <p
                                        className="learn-more-txt"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                inputValues['termsAndCondition']?.learnMore
                                        }} />
                                )}

                                {slug === 'agentforce-research-sign-up' && (
                                    <p className="learn-more-txt">
                                        We intend to use a Salesforce Agentforce AI agent to collect and use feedback under this research program. This is optional, you do not have to proceed. If you do proceed, we will handle your personal data in accordance with our <a href="https://www.salesforce.com/company/privacy/full_privacy.jsp" target="_blank" >Privacy Statement</a>. This research program is governed by the <a href="https://www.salesforce.com/company/program-agreement/" target="_blank">Salesforce Program Agreement</a>.
                                    </p>

                                )}
                            </div>
                        )}

                        <div className='privacy-statement'>
                            <div class="slds-form-element" id="recaptcha-widget">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={process.env.GATSBY_OPTIN_RESEARCH_RECAPTCHA_SITE_KEY}
                                    onChange={handleRecaptcha}
                                    onExpired={handleRecaptchaFail}
                                    onErrored={handleRecaptchaFail} />
                            </div>
                            <div class="slds-form-element__help" id="recaptcha-error">{fieldErrors['recaptcha-widget']} </div>
                        </div>

                        <div className="slds-m-top_large">
                            <div className="slds-m-vertical_xx-large slds-text-align_left">
                                {isLoading ?
                                    <>
                                        <div className="loader"></div>
                                        <span className="loading-text">Loading....</span>
                                    </>
                                    :
                                    <tds-button variant="brand" onClick={handleSubmitForm}>
                                        SUBMIT
                                    </tds-button>
                                }
                            </div>
                        </div>
                    </>
                )}
                {apiMessage?.status && (
                    <div className='success-page'>
                        {apiMessage?.status === 'success' ?
                            <>
                                <p className='title'>
                                    Thank you for your submission!
                                </p>
                                <p className='desc'>
                                    The Salesforce experience design team will be in contact soon to invite you to opportunities relevant to you. To unsubscribe from Salesforce Customer Success Research communications, please email <u className='email-txt'>xdresearch@salesforce.com</u>.
                                </p>
                            </>
                            :
                            <p className='error-txt'>Error: your form did not submit correctly. Please contact <u>xdresearch@salesforce.com.</u></p>
                        }
                    </div>
                )}
            </div>
        </LWCLayout>
    )
}

export default OptInResearch;